import { z } from 'zod';
import { withNewPassword } from '../../password';

export const createAccountSchema = withNewPassword({
    email: z.string().email("That doesn't look like a valid email. Please check the format."),
});
